export type ResearchNodeId = 'BOOTSTRAP_RESERVE' | 'TARGETING_ORACLE' | 'BOUNTY_ROUTER' | 'EXECUTION_CACHE' | 'CLOCK_SYNC' | 'DEEP_RESERVES'

export interface ResearchNode {
  readonly id: ResearchNodeId
  readonly level: number
  readonly name: string
  readonly branch: 'ECONOMY' | 'DEFENSE' | 'NETWORK'
  readonly glyph: string
  readonly description: string
  readonly stat: string
  readonly color: string
}

export interface ResearchBonuses {
  readonly startingCapital: number
  readonly towerDamage: number
  readonly towerAttackSpeed: number
  readonly towerRange: number
  readonly killRewards: number
}

export const RESEARCH_NODES: readonly ResearchNode[] = [
  { id: 'BOOTSTRAP_RESERVE', level: 2, name: 'BOOTSTRAP RESERVE', branch: 'ECONOMY', glyph: '₮', description: 'Pre-allocates tactical liquidity before every deployment.', stat: '+250 STARTING USDT', color: '#ffd377' },
  { id: 'TARGETING_ORACLE', level: 4, name: 'TARGETING ORACLE', branch: 'NETWORK', glyph: '⌖', description: 'Persistent prediction models extend every defense envelope.', stat: '+5% TOWER RANGE', color: '#35d8ea' },
  { id: 'BOUNTY_ROUTER', level: 6, name: 'BOUNTY ROUTER', branch: 'ECONOMY', glyph: '↗', description: 'Routes hostile liquidation value directly into the reserve.', stat: '+10% KILL REWARDS', color: '#47e2ae' },
  { id: 'EXECUTION_CACHE', level: 8, name: 'EXECUTION CACHE', branch: 'DEFENSE', glyph: '✦', description: 'Stores optimized payload patterns for every tower family.', stat: '+8% TOWER DAMAGE', color: '#ff7fcf' },
  { id: 'CLOCK_SYNC', level: 10, name: 'CLOCK SYNC', branch: 'NETWORK', glyph: '⌬', description: 'Synchronizes defense cadence with the validator clock.', stat: '+8% ATTACK SPEED', color: '#8b73ff' },
  { id: 'DEEP_RESERVES', level: 12, name: 'DEEP RESERVES', branch: 'ECONOMY', glyph: '⬢', description: 'Unlocks the account treasury for high-threat operations.', stat: '+500 STARTING USDT', color: '#ffb347' },
]

export function researchBonuses(level: number): ResearchBonuses {
  return {
    startingCapital: (level >= 2 ? 250 : 0) + (level >= 12 ? 500 : 0),
    towerRange: level >= 4 ? 1.05 : 1,
    killRewards: level >= 6 ? 1.1 : 1,
    towerDamage: level >= 8 ? 1.08 : 1,
    towerAttackSpeed: level >= 10 ? 1.08 : 1,
  }
}
